import React, { useState, useEffect, useMemo, useRef } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css'
import {sdk} from './sdk.js';
import {sdkLocal} from './sdkLocal.js';
import './SocialTopShortcut.css';
import { 
    FaUsers, FaGift, FaBriefcase, FaQuestionCircle, FaHandsHelping, FaDiceFive,
    FaWarehouse, FaShoppingCart, FaLaptopHouse, FaWallet, FaQuestion
} from 'react-icons/fa';
import LiberiumLink from "./LiberiumLink.js";

const SocialTopShortcut = () => {
    const [linkClicks, setLinkClicks] = useState([]);
    const [expanded, setExpanded] = useState(false);
    const [balance, setBalance] = useState(0);
    const [loadingBalance, setLoadingBalance] = useState(true);

    useEffect(() => {
        // Charger les données des clics de localStorage
        const storedClicks = JSON.parse(localStorage.getItem("linkClicks")) || {};
        const sortedClicks = Object.entries(storedClicks)
            .sort(([, a], [, b]) => b - a) // Trier par nombre de clics décroissant
            .map(([href]) => href);
        setLinkClicks(sortedClicks);
    }, []);

    // Charger le solde de l'utilisateur
    useEffect(() => {
        const fetchBalance = async () => {
            try {
                setLoadingBalance(true);
                const balanceResponse = await sdk.models.PeupleUser.getAccountBalance();
                if (balanceResponse && typeof balanceResponse.balance !== 'undefined') {
                    setBalance(parseFloat(balanceResponse.balance));
                }
            } catch (err) {
                console.error("Erreur lors de la récupération du solde:", err);
                setBalance(0);
            } finally {
                setLoadingBalance(false);
            }
        };

        fetchBalance();
    }, []);

    const recordClick = (href) => {
        const storedClicks = JSON.parse(localStorage.getItem("linkClicks")) || {};
        storedClicks[href] = (storedClicks[href] || 0) + 1; // Incrémenter le compteur
        localStorage.setItem("linkClicks", JSON.stringify(storedClicks));

        // Recalculer et trier
        const sortedClicks = Object.entries(storedClicks)
            .sort(([, a], [, b]) => b - a)
            .map(([href]) => href);
        setLinkClicks(sortedClicks);
    };

    const links = [
        { href: "/demarrage", icon: FaQuestion, label: "Démarrage" },
        //{ href: "/placedumarche", icon: FaShoppingCart, label: "Boutique" },
        { href: "/participants", icon: FaUsers, label: "Participants" },
        { href: "/cadeaux", icon: FaGift, label: "Cadeaux" },
        { href: "/worker", icon: FaBriefcase, label: "Travailler" },
        { href: "/tele-travail", icon: FaLaptopHouse, label: "Télé-travail" },
        { href: "/services", icon: FaHandsHelping, label: "Services" },
        { href: "/games/quiz", icon: FaQuestionCircle, label: "Quiz" },
        { href: "/games/bingo", icon: FaDiceFive, label: "Bingo" },
        { href: "/portefeuille", icon: FaWallet, label: "Portefeuille", condition: !loadingBalance && parseFloat(balance) > 0 },
        //{ href: "/partenaire/entrepot", icon: FaWarehouse, label: "Entrepôt" },        
    ];

    // Liens triés par clics
    const sortedLinks = linkClicks
        .map((href) => links.find((link) => link.href === href))
        .filter(Boolean);
    
    // Filtrer les liens selon leurs conditions
    const validLinks = sortedLinks.concat(links.filter((link) => !sortedLinks.includes(link)))
        .filter(link => link.condition !== false);
    
    // Afficher tous les liens ou seulement les 5 premiers
    const visibleLinks = expanded 
        ? validLinks
        : validLinks.slice(0, 5);

    return (
        <div className={`shortcut-container ${expanded ? 'expanded' : ''}`}>
            {visibleLinks.map(({ href, icon: Icon, label }) => (
                <LiberiumLink key={href} href={href} passHref>
                    <div className="shortcut-item" onClick={() => recordClick(href)}>
                        <div className="shortcut-icon" style={{ position: 'relative' }}>
                            <Icon size={expanded ? 26 : 22} />
                            {href === '/portefeuille' && parseFloat(balance) > 0 && (
                                <div style={{
                                    position: 'absolute',
                                    top: '-8px',
                                    right: '-8px',
                                    backgroundColor: '#28a745',
                                    color: 'white',
                                    borderRadius: '10px',
                                    padding: '1px 4px',
                                    fontSize: '8px',
                                    fontWeight: 'bold',
                                    minWidth: '16px',
                                    textAlign: 'center',
                                    boxShadow: '0 1px 2px rgba(0,0,0,0.3)',
                                    whiteSpace: 'nowrap',
                                    lineHeight: '1.2'
                                }}>
                                    {parseFloat(balance).toFixed(0)}$
                                </div>
                            )}
                        </div>
                        <p className="shortcut-label">{label}</p>
                    </div>
                </LiberiumLink>
            ))}
            
            {validLinks.length > 5 && (
                <div className="shortcut-item" onClick={() => setExpanded(!expanded)}>
                    <div className="shortcut-icon">
                        {expanded ? (
                            <div style={{ fontSize: "22px", fontWeight: "bold" }}>−</div>
                        ) : (
                            <div style={{ fontSize: "22px", fontWeight: "bold" }}>+</div>
                        )}
                    </div>
                    <p className="shortcut-label">{expanded ? "Réduire" : "Plus"}</p>
                </div>
            )}
        </div>
    );
};

export { SocialTopShortcut };